import { render, staticRenderFns } from "./mda.vue?vue&type=template&id=a32511dc&"
import script from "./mda.vue?vue&type=script&lang=js&"
export * from "./mda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports